import React from "react"
import MapComponent from '../components/map/map';
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <MapComponent />
  </Layout>
)

export default IndexPage
